<template>
  <div>
    <div class="d-flex mb-2">
      <fixed-label-filter v-if="isAdminMode && l3PermissionEnable" :label="$t('dictionary.domain')">
        <base-select
          v-model="domainId"
          resource="domains"
          :params="domainParams"
          remote
          :select-props="{ placeholder: $t('rules.domain'), allowClear: true }"
          @change="handleDomainChange">
          <template #optionTemplate="{ options }">
            <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
              {{item.name}}
            </a-select-option>
          </template>
        </base-select>
      </fixed-label-filter>
      <fixed-label-filter :class="isAdminMode && l3PermissionEnable ? 'ml-2' : ''" :label="$t('dictionary.project')">
        <base-select
          v-model="projectId"
          resource="projects"
          :params="projectParams"
          remote
          :select-props="{ placeholder: $t('rules.project'), allowClear: true }"
          @change="handleProjectChange">
          <template #optionTemplate="{ options }">
            <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
              {{item.name}}
            </a-select-option>
          </template>
        </base-select>
      </fixed-label-filter>
    </div>
    <custom-report :template-list="templateList" :is-template-edit="isTemplateEdit" :is-page="isPage" :type="type" :domain-id="domainId" :project-id="projectId" :hide-empty="hideEmpty" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomReport from './index.vue'

export default {
  name: 'TemplateViewer',
  components: {
    CustomReport,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    templateList: {
      type: Array,
      default: () => [],
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'daily',
    },
    hideEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      domainId: undefined,
      projectId: undefined,
    }
  },
  computed: {
    ...mapGetters(['scope', 'userInfo', 'isAdminMode', 'l3PermissionEnable']),
    domainParams () {
      return {
        scope: this.scope,
        limit: 20,
      }
    },
    projectParams () {
      const params = {
        scope: this.scope,
        limit: 20,
      }
      if (this.domainId) {
        params.domain_id = this.domainId
      }
      return params
    },
  },
  methods: {
    handleDomainChange () {
      this.projectId = undefined
      this.$emit('domain-change', this.domainId)
    },
    handleProjectChange () {
      this.$emit('project-change', this.projectId)
    },
  },
}
</script>
